import { Subject } from 'rxjs';
import { Injectable } from "@angular/core";

@Injectable( {
    providedIn: 'root'
} )
export class FilterService {
    clearFilters: Subject<boolean> = new Subject<boolean>();
    inititialvalue: Subject<number> = new Subject<number>();
}